<label class="switch">
  <input
    checked
    [(ngModel)]="checked"
    (change)="checkboxChange($event)"
    type="checkbox"
  />
  <span class="slider round"></span>
</label>
